const entryId = process.env.ZOOM_ENTRY_ID;
const zoomScriptUrl = process.env.ZOOM_SCRIPT_URL;
const handleOpenChat = () => {
  if (typeof window?.$zopim !== 'undefined') {
    window?.$zopim.livechat.window.show();
  } else if ('adaEmbed' in window) {
    // Opens ada
    window?.adaEmbed.toggle();
  }
};

const zoomTrigger = async () => {
  // eslint-disable-next-line no-undef
  const videoClient = new VideoClient({
  });
  await videoClient.init({
    entryId,
  });
  videoClient.startVideo();
};

const handleOpenZoom = (element) => {
  let zoomLoaded = false;
  element.preventDefault();
  if (zoomLoaded === false) {
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('data-entry-id', entryId);
    script.setAttribute('src', zoomScriptUrl);
    script.onload = async () => {
      zoomTrigger();
      zoomLoaded = true;
    };
    document.body.appendChild(script);
  } else {
    zoomTrigger();
  }
};

const ThirdPartyService = {
  handleOpenChat,
  handleOpenZoom,
};

export default ThirdPartyService;
